import { formatAccountNo } from "us.collection.economy/functions";
import { ISaveRegisterPayment } from "../interface";
import dayjs from "dayjs";

export function SaveRegisterPayments(this: ISaveRegisterPayment) {
  let transactions: any = [];
  this.caseDetails.map((cd: any) => {
    transactions.push({
      amount: cd.amount,
      caseId: cd.caseId,
      pid: cd.pid,
      caseType: cd.caseType
    });
  });
  return {
    voucherNo: this.voucherNo,
    paymentTypeId: this.paymentType,
    subTypeId: this.paymentMethod,
    voucherDate: dayjs(this.datePaid.toDate()).format("YYYY-MM-DD"),
    payerBankAccount: formatAccountNo(this.accountNo),
    paymentAmount: this.voucherAmount,
    voucherRef: this.voucherReference,
    ledgerAccount: this.ledgerAccountNo,
    voucherTransactions: transactions,
    paymentTypeCode: this.paymentTypeCode,
    kid: this.kid
  };
}
